import PropTypes from 'prop-types';
import { BLOCKS, INLINES } from '@contentful/rich-text-types';

import Link from '../../../Core/Link';
import Container from '../../../Core/Container';
import RichText, { fragment } from '../../../Core/RichText';
import TextWithIcon from '../../TextWithIcon';

import { Header, Footer } from './styles';

const IconWithTextList = ({ data }) => {
  if (!data) return null;
  const { backgroundColor, header, bodyCopy, listOfFeatures, ctas } = data;

  const body = {
    renderNode: {
      [BLOCKS.PARAGRAPH]: (_, children) => <span>{children}</span>,
      [INLINES.HYPERLINK]: (node, children) => {
        const { data: link } = node;
        return (
          <Link className="rich-text-link" to={link.uri} fontSize="inherit">
            {children}
          </Link>
        );
      },
    },
  };

  return (
    <Container className="auto-margin" backgroundColor={backgroundColor}>
      <Header>
        {header && <RichText document={header} />}
        {bodyCopy && <RichText document={bodyCopy} />}
      </Header>
      {listOfFeatures &&
        listOfFeatures.map(list => (
          <TextWithIcon
            key={list.id}
            type="icon-with-text"
            icon={list.iconDam.asset.localImage.publicURL}
          >
            <RichText document={list.text} options={body} />
          </TextWithIcon>
        ))}
      {ctas && (
        <Footer>
          {ctas &&
            ctas.map(cta => {
              if (cta.hideFrench === true) return null;
              return (
                <Link key={cta.id} data={cta}>
                  <RichText document={cta.label} options={fragment} />
                </Link>
              );
            })}
        </Footer>
      )}
    </Container>
  );
};

IconWithTextList.propTypes = {
  data: PropTypes.shape().isRequired,
};

export default IconWithTextList;
